/**
 * Cart Drawer Discount Functionality
 */
class CartDrawerDiscount {
  constructor() {
    this.init();
  }
  
  init() {
    this.discountInput = document.querySelector('.cart-drawer__discount-input');
    this.discountButton = document.querySelector('.cart-drawer__discount-button');
    this.discountError = document.querySelector('.cart-drawer__discount-error');
    this.discountCancelButton = document.querySelector('[data-action="remove-discount"]');

    
    if (this.discountInput && this.discountButton) {
      this.attachEventListeners();
    }
    
    if (this.discountCancelButton) {
      this.attachCancelListener();
    }
  }
  
  attachEventListeners() {
    // Remove any existing listeners first
    this.removeEventListeners();
    
    // Store bound functions for removal later
    this.boundHandleKeypress = this.handleKeypress.bind(this);
    this.boundHandlePaste = this.handlePaste.bind(this);
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    this.boundApplyDiscount = this.applyDiscount.bind(this);
    
    // Prevent comma input
    this.discountInput.addEventListener('keypress', this.boundHandleKeypress);
    
    // Handle paste to remove commas
    this.discountInput.addEventListener('paste', this.boundHandlePaste);
    
    // Handle Enter key
    this.discountInput.addEventListener('keydown', this.boundHandleKeydown);
    
    // Handle button click
    this.discountButton.addEventListener('click', this.boundApplyDiscount);
  }
  
  attachCancelListener() {
    if (this.boundRemoveDiscount) {
      this.discountCancelButton.removeEventListener('click', this.boundRemoveDiscount);
    }
    
    this.boundRemoveDiscount = this.removeDiscount.bind(this);
    this.discountCancelButton.addEventListener('click', this.boundRemoveDiscount);
  }
  
  removeEventListeners() {
    if (this.discountInput) {
      this.discountInput.removeEventListener('keypress', this.boundHandleKeypress);
      this.discountInput.removeEventListener('paste', this.boundHandlePaste);
      this.discountInput.removeEventListener('keydown', this.boundHandleKeydown);
    }
    
    if (this.discountButton) {
      this.discountButton.removeEventListener('click', this.boundApplyDiscount);
    }
    
    if (this.discountCancelButton && this.boundRemoveDiscount) {
      this.discountCancelButton.removeEventListener('click', this.boundRemoveDiscount);
    }
  }
  
  handleKeypress(e) {
    if (e.key === ',') {
      e.preventDefault();
    }
  }
  
  handlePaste(e) {
    e.preventDefault();
    const pastedText = (e.clipboardData || window.clipboardData).getData('text');
    const cleanedText = pastedText.replace(/,/g, '');
    this.discountInput.value = cleanedText;
  }
  
  handleKeydown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.applyDiscount();
    }
  }
  
  async applyDiscount() {
    const discountCode = this.discountInput.value.trim();
    
    if (!discountCode) {
      return;
    }
    
    // Disable button and input during request
    this.discountButton.disabled = true;
    this.discountInput.disabled = true;
    
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          discount: discountCode
        })
      });
      
      if (response.ok) {
        const cartData = await response.json();
        
        // Check if discount code was applied successfully
        let discountApplied = false;
        
        // Check the discount_codes array for our code
        if (cartData.discount_codes && Array.isArray(cartData.discount_codes)) {
          const appliedDiscount = cartData.discount_codes.find(discount => 
            discount.code && discount.code.toLowerCase() === discountCode.toLowerCase()
          );
          
          // Check if the discount is applicable
          discountApplied = appliedDiscount && appliedDiscount.applicable === true;
        }
        
        if (discountApplied) {
          // Success - refresh cart
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          
          // Clear input
          this.discountInput.value = '';
        } else {
          // Discount code not applicable
          this.showError();
        }
      } else {
        // Show error
        this.showError();
      }
    } catch (error) {
      console.error('Discount application error:', error);
      // Show error
      this.showError();
    } finally {
      // Re-enable button and input
      this.discountButton.disabled = false;
      this.discountInput.disabled = false;
      this.discountInput.focus();
    }
  }
  
  async removeDiscount() {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          discount: ''
        })
      });
      
      if (response.ok) {
        // Success - refresh cart
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    } catch (error) {
      console.error('Discount removal error:', error);
    }
  }
  
  showError() {
    // Show error message
    this.discountError.hidden = false;
    
    // Hide error after 5 seconds
    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
    }
    
    this.errorTimeout = setTimeout(() => {
      this.discountError.hidden = true;
    }, 5000);
  }
  
  destroy() {
    this.removeEventListeners();
    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
    }
  }
}

// Global instance
let cartDrawerDiscountInstance = null;

// Function to initialize or reinitialize
function initializeCartDrawerDiscount() {
  // Destroy existing instance and create new one
  if (cartDrawerDiscountInstance) {
    cartDrawerDiscountInstance.destroy();
  }
  
  cartDrawerDiscountInstance = new CartDrawerDiscount();
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeCartDrawerDiscount);

// Reinitialize when cart is refreshed
document.addEventListener('cart:refresh', () => {
  setTimeout(initializeCartDrawerDiscount, 500);
});

document.addEventListener('cart:change', () => {
  setTimeout(initializeCartDrawerDiscount, 500);
});



// ADDITIONAL EVENTS FOR THEME CUSTOMIZER
// Handle Shopify section events for theme editor
document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.sectionId.includes('cart-drawer')) {
    setTimeout(initializeCartDrawerDiscount, 500);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  if (event.detail.sectionId.includes('cart-drawer') && cartDrawerDiscountInstance) {
    cartDrawerDiscountInstance.destroy();
  }
}); 